import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import BlogRelatedCard from "./relatedCard";

import { Col, Container, Row } from "react-bootstrap";

import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";

import { useSiteConfig } from "../../context/SiteConfigContext";

function DetailPage() {
  const { slug } = useParams();

  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [metaData, setMetaData] = useState({});

  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const params = {
        limit: 4,
      };

      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;

        setItem(blog || {});
        setRelatedBlogs(relatedBlogs || []);
        setMetaData(blog?.meta || {});
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return (
      words[0][0] + words[words.length - 1][0]
    ).toUpperCase();
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.title} middle="" />

      <SEO meta={metaData} />

      <div className="premium-detail-page">

        {/* =========================================
            BLOG HERO
        ========================================= */}

        <section className="blog-detail-hero">

          {/* Large Image */}
          <div className="blog-detail-hero-image">

            <img
              src={item?.image}
              alt={item?.title || "Blog"}
            />

            <div className="blog-detail-hero-overlay"></div>

            <div className="blog-detail-hero-meta">
              <span>CYCLING JOURNAL</span>

              <i></i>

              <span>
                {item?.date
                  ? formatDate(item?.date)
                  : ""}
              </span>
            </div>

          </div>


          {/* Floating Intro Card */}
          <div className="container blog-detail-intro-wrap">

            <div className="blog-detail-intro">

              <div className="blog-detail-intro-label">
                <span></span>
                FEATURED STORY
              </div>

              <h1>
                {item?.title}
              </h1>

              {item?.shortDescription && (
                <p>
                  {item.shortDescription}
                </p>
              )}

              <div className="blog-detail-author">

                <div className="blog-detail-author-avatar">
                  {getInitials(item?.author)}
                </div>

                <div>
                  <strong>
                    {item?.author}
                  </strong>

                  <span>
                    Published on{" "}
                    {item?.date
                      ? formatDate(item?.date)
                      : ""}
                  </span>
                </div>

              </div>

            </div>

          </div>

        </section>


        {/* =========================================
            ARTICLE CONTENT
        ========================================= */}

        <section className="blog-detail-content-section">

          <Container>

            <Row className="justify-content-center">

              {/* =====================================
                  SOCIAL SHARE
              ===================================== */}

              <Col
                lg={2}
                className="d-none d-lg-block"
              >

                <div className="blog-share-box">

                  <span>SHARE</span>

                  <div className="blog-share-line"></div>


                  {config?.socialMedia?.facebook && (
                    <a
                      href={
                        config.socialMedia.facebook
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="blog-share-icon"
                    >
                      <FaFacebook size={15} />
                    </a>
                  )}


                  {config?.socialMedia?.instagram && (
                    <a
                      href={
                        config.socialMedia.instagram
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="blog-share-icon"
                    >
                      <FaInstagram size={15} />
                    </a>
                  )}


                  {config?.socialMedia?.twitter && (
                    <a
                      href={
                        config.socialMedia.twitter
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="blog-share-icon"
                    >
                      <FaTwitter size={15} />
                    </a>
                  )}


                  {config?.socialMedia?.youtube && (
                    <a
                      href={
                        config.socialMedia.youtube
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="blog-share-icon"
                    >
                      <FaYoutube size={15} />
                    </a>
                  )}


                  {config?.socialMedia?.linkedin && (
                    <a
                      href={
                        config.socialMedia.linkedin
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="blog-share-icon"
                    >
                      <FaLinkedin size={15} />
                    </a>
                  )}

                </div>

              </Col>


              {/* =====================================
                  MAIN ARTICLE
              ===================================== */}

              <Col lg={7}>

                <article className="blog-article">

                  <div
                    className="blog-article-body"
                    dangerouslySetInnerHTML={{
                      __html: item?.description || "",
                    }}
                  />


                  {/* =================================
                      RELATED STORIES
                  ================================= */}

                  {relatedBlogs &&
                    relatedBlogs.length > 0 && (

                      <div className="blog-related-section">

                        <div className="blog-related-heading">

                          <div>
                            <span>
                              KEEP READING
                            </span>

                            <h2>
                              More Stories
                            </h2>
                          </div>

                        </div>


                        <div className="row g-3">

                          {relatedBlogs.map(
                            (blog, index) => (
                              <div
                                key={
                                  blog?._id ||
                                  index
                                }
                                className="col-12"
                              >
                                <BlogRelatedCard
                                  item={blog}
                                />
                              </div>
                            ),
                          )}

                        </div>


                        <div className="text-center mt-4">

                          <Link
                            to="/blog"
                            className="blog-view-all"
                          >
                            View All Stories

                            <span>
                              →
                            </span>
                          </Link>

                        </div>

                      </div>
                    )}

                </article>

              </Col>

            </Row>

          </Container>

        </section>

      </div>
    </>
  );
}

export default DetailPage;